// extracted by mini-css-extract-plugin
export default {"controls":"ScrollControls_controls__9MjYm","button":"ScrollControls_button__jzuQb","chevronUp":"ScrollControls_chevronUp__1iTVx","chevronDown":"ScrollControls_chevronDown__ng7zM"};